import { render, staticRenderFns } from "./RiskComponent.vue?vue&type=template&id=79d10a0c&scoped=true&"
import script from "./RiskComponent.vue?vue&type=script&lang=js&"
export * from "./RiskComponent.vue?vue&type=script&lang=js&"
import style0 from "./RiskComponent.vue?vue&type=style&index=0&id=79d10a0c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d10a0c",
  null
  
)

export default component.exports